module.exports = __webpack_public_path__ + "static/img/90057B_1_C_20210406_LC.56e3430.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/90057B_1_C_20210406_LC.png
// module id = js0m
// module chunks = 0